import * as z from "zod/v4";

export const deleteUpsGhostAccount = {
  name: "deleteUpsGhostAccount" as const,
  input: z.object({ locationId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
